import { render, staticRenderFns } from "./Empower.vue?vue&type=template&id=0dc5090e&scoped=true&"
import script from "./Empower.vue?vue&type=script&lang=js&"
export * from "./Empower.vue?vue&type=script&lang=js&"
import style0 from "./Empower.vue?vue&type=style&index=0&id=0dc5090e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc5090e",
  null
  
)

export default component.exports